import styled from "styled-components"
import { media } from "../../../styles"

import { Link } from "gatsby"

export const ButtonLink = styled(Link)`
  text-decoration: none;
  width: min-content;
`

export const ButtonContainer = styled.span`
  display: inline-flex;
  width: 100%;

  font-weight: 600;

  justify-content: space-between;
  align-items: center;

  padding: 1.5rem 2.2rem;
  border-radius: 6.5rem;
  white-space: nowrap;
  width: min-content;

  transition: transform 0.4s ease;
  cursor: pointer;

  &:hover {
    transform: scale(0.96);
  }
`

export const ButtonContainerBlue = styled(ButtonContainer)`
  background-color: var(--color-blue-light);
  border: solid 2px var(--color-blue-light);
  color: var(--color-white);
`

export const ButtonContainerWhite = styled(ButtonContainer)`
  background-color: var(--color-white);
  border: solid 2px var(--color-white);
  color: var(--color-black);
`

export const ButtonContainerSecondaryBlack = styled(ButtonContainer)`
  border: solid 3px var(--color-black);
  color: var(--color-black);
`
export const ButtonContainerSecondaryWhite = styled(ButtonContainer)`
  border: solid 3px var(--color-white);
  color: var(--color-white);
`

export const ButtonContainerWhiteForm = styled.button`
  display: flex;
  width: 100%;

  max-width: 40rem;

  justify-content: space-between;
  align-items: center;

  padding: 1rem 2rem;
  border-radius: 6.5rem;

  transition: transform 0.4s ease;
  cursor: pointer;

  &:hover {
    transform: scale(0.96);
  }

  ${media.phone`
  padding: .6rem 1.2rem;
  `}

  background-color: var(--color-white);
  border: solid 2px var(--color-white);
  color: var(--color-black);
`

export const ButtonContainerBlueForm = styled.button`
  display: flex;
  width: 100%;

  max-width: 40rem;

  justify-content: space-between;
  align-items: center;

  padding: 1rem 2rem;
  border-radius: 6.5rem;

  transition: transform 0.4s ease;
  cursor: pointer;

  &:hover {
    transform: scale(0.96);
  }

  ${media.phone`
  /* padding: .6rem 1.2rem; */
  `}

  background-color: var(--color-blue-light);
  border: solid 2px var(--color-blue-light);
  color: var(--color-white);
`

export const ButtonContainerNav = styled(ButtonContainer)`
  border: solid 3px var(--color-white);
  color: var(--color-white);

  ${media.phone`
  padding: 1rem 1.6rem;

  & img{
    display: none;
  }
  `}
`

export const ButtonText = styled.p`
  font-family: var(--font-body);
  font-size: var(--font-size-button);

  text-transform: uppercase;
  text-decoration: none;

  white-space: nowrap;

  margin-right: ${props => props.textMargin};

  ${media.phone`
  font-size: var(--font-size-buttonS);
  margin-right: calc(${props => props.textMargin} - 4rem);

  `};
`
export const ButtonIcon = styled.div`
  margin-left: 2rem;

  ${media.phone`
   display: ${props => (props.noArrow ? "none" : "block")};
`}

  ${media.phonesmall`
  margin-left: 1rem;
`}
`
